(() => {
  const PRODUCT_SELECTOR = 'product-info[data-product-handle="birkenstock-arizona-rivets-suede-sandals"]';
  const COLOR_NAMES = ['Pepper', 'Taupe', 'Black Suede'];
  let productVariants = null;

  const updateShippingMessages = () => {
    if (!document.body) return;
    const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    let textNode = walker.nextNode();

    while (textNode) {
      const parent = textNode.parentElement;
      if (parent && !parent.closest('script, style, template')) {
        textNode.nodeValue = textNode.nodeValue.replace(
          /FREE US SHIPPING ON ORDERS \$50\+/gi,
          'FREE US SHIPPING ON ORDERS $150+'
        );
      }
      textNode = walker.nextNode();
    }
  };

  const getOptionName = (optionGroup) => {
    const title = optionGroup.querySelector('.option-label--title')?.textContent?.trim() || '';
    return title.replace(':', '').trim();
  };

  const setEditorialColor = (color) => {
    if (!COLOR_NAMES.includes(color)) return;

    document.querySelectorAll('[data-arizona-color-card]').forEach((card) => {
      const isActive = card.dataset.arizonaColorCard === color;
      card.classList.toggle('is-active', isActive);
      card.setAttribute('aria-pressed', String(isActive));
    });

    document.querySelectorAll('[data-arizona-color-look-panel]').forEach((panel) => {
      const isActive = panel.dataset.arizonaColorLookPanel === color;
      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });
  };

  const decorateOptions = (root) => {
    if (!root) return;

    root.querySelectorAll('.m-product-option__inner').forEach((optionGroup) => {
      const optionName = getOptionName(optionGroup);
      const optionCount = optionGroup.querySelectorAll('.m-product-option__input').length;
      optionGroup.dataset.optionName = optionName;

      optionGroup.classList.toggle('arizona-single-option', optionName === 'Fit' && optionCount === 1);

      if (optionName !== 'Color') return;
      optionGroup.querySelectorAll('.m-product-option--node').forEach((node) => {
        const value = node.dataset.value || node.querySelector('input')?.value || '';
        if (!COLOR_NAMES.includes(value)) return;

        node.classList.add('arizona-color-option');
        node.dataset.colorLabel = value;

        const swatch = node.querySelector('.m-product-option--node__label');
        if (!swatch) return;
        const swatchImage = swatch.style.backgroundImage;
        if (swatchImage && swatchImage !== 'none') {
          swatch.style.setProperty('--arizona-swatch-image', swatchImage);
        }
      });
    });
  };

  const initializeMediaGuard = (root) => {
    if (!root || root.dataset.arizonaMediaGuardReady === 'true') return;
    if (typeof root.updateMedia !== 'function') return;

    const originalUpdateMedia = root.updateMedia.bind(root);
    const getSelectedColor = () => root.querySelector('input[name^="Color"]:checked')?.value || '';

    root.dataset.arizonaMediaColor = getSelectedColor();
    root.updateMedia = (variant) => {
      const selectedColor = getSelectedColor();
      const colorChanged = selectedColor && selectedColor !== root.dataset.arizonaMediaColor;

      root.dataset.arizonaMediaColor = selectedColor;
      if (!colorChanged) return;

      originalUpdateMedia(variant);
    };

    root.dataset.arizonaMediaGuardReady = 'true';
  };

  const selectColor = (color) => {
    const root = document.querySelector(PRODUCT_SELECTOR);
    if (!root) return;

    const input = [...root.querySelectorAll('input[name^="Color"]')].find((item) => item.value === color);
    if (!input) return;

    if (!productVariants) {
      const variantsScript = [...document.querySelectorAll('script[type="application/json"]')]
        .find((script) => script.textContent.trim().startsWith('[{"id"'));
      try {
        productVariants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
      } catch (error) {
        productVariants = [];
      }
    }

    const fit = root.querySelector('input[name^="Fit"]:checked')?.value || 'Regular';
    const size = root.querySelector('input[name^="Size"]:checked')?.value || '';
    const variant = productVariants.find((item) => (
      item.option1 === color && item.option2 === fit && item.option3 === size
    ));

    input.checked = true;

    const colorGroup = input.closest('.m-product-option__inner');
    if (colorGroup) {
      colorGroup.dataset.selectedValue = color;
      const selectedLabel = colorGroup.querySelector('.option-label--selected');
      if (selectedLabel) selectedLabel.textContent = color;
    }

    const selectedColorLabel = root.querySelector('[data-arizona-selected-color]');
    if (selectedColorLabel) selectedColorLabel.textContent = color;

    if (variant) {
      root.currentVariant = variant;
      root.updateMedia?.(variant);
      root.updateURL?.(root.dataset.url, variant.id);

      document.querySelectorAll('form[action*="/cart/add"] input[name="id"]').forEach((variantInput) => {
        variantInput.value = variant.id;
        variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      });

      const selectedVariantData = root.querySelector('variant-picker [data-selected-variant]');
      if (selectedVariantData) selectedVariantData.textContent = JSON.stringify(variant);

      root.toggleAddButton?.(
        !variant.available,
        variant.available ? window.MinimogStrings.addToCart : window.MinimogStrings.soldOut
      );
    }

    setEditorialColor(color);
  };

  const initializeSizeGuide = (root) => {
    if (!root) return;
    initializeMediaGuard(root);
    decorateOptions(root);
    if (root.dataset.arizonaSizeReady === 'true') return;

    const selectedColorLabel = root.querySelector('[data-arizona-selected-color]');
    const updateSelectedColor = () => {
      const checkedColor = root.querySelector('input[name^="Color"]:checked');
      if (selectedColorLabel && checkedColor) selectedColorLabel.textContent = checkedColor.value;
      if (checkedColor) setEditorialColor(checkedColor.value);
    };
    updateSelectedColor();
    root.addEventListener('change', (event) => {
      if (event.target.matches('input[name^="Color"]')) updateSelectedColor();
    });

    let decorating = false;
    const observer = new MutationObserver(() => {
      if (decorating) return;
      decorating = true;
      requestAnimationFrame(() => {
        decorateOptions(root);
        updateSelectedColor();
        decorating = false;
      });
    });
    observer.observe(root, { childList: true, subtree: true });

    const component = root.querySelector('[data-arizona-size-guide]');
    if (!component) return;

    const overlay = component.querySelector('[data-arizona-size-overlay]');
    const openButton = component.querySelector('[data-arizona-size-open]');
    const closeButton = component.querySelector('[data-arizona-size-close]');
    if (!overlay || !openButton || !closeButton) return;

    // The theme's sticky product column uses transforms, which would otherwise
    // trap a fixed modal inside that column. Portaling it to <body> keeps the
    // guide centered in the viewport on desktop and mobile.
    if (overlay.parentElement !== document.body) document.body.appendChild(overlay);

    let previousFocus = null;

    const open = () => {
      previousFocus = document.activeElement;
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.classList.add('arizona-modal-open');
      closeButton.focus();
    };

    const close = () => {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('arizona-modal-open');
      if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
    };

    openButton.addEventListener('click', open);
    closeButton.addEventListener('click', close);
    overlay.addEventListener('click', (event) => {
      if (event.target === overlay) close();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && overlay.classList.contains('is-open')) close();
    });

    root.dataset.arizonaSizeReady = 'true';
  };

  const initializeSizeReturn = () => {
    const root = document.querySelector(PRODUCT_SELECTOR);
    const button =
      root?.querySelector('[data-arizona-size-return]') ||
      document.querySelector('[data-arizona-size-return]');

    if (!root || !button || button.dataset.arizonaSizeReturnReady) return;

    button.dataset.arizonaSizeReturnReady = 'true';

    // Portaling keeps the chip pinned to the viewport even inside the theme's
    // transformed sticky product column.
    if (button.parentElement !== document.body) document.body.appendChild(button);

    const mobileQuery = window.matchMedia('(max-width: 767px)');
    let animationFrame = null;

    const getSizeTarget = () =>
      root.querySelector('.m-product-option__inner[data-option-name="Size"]') ||
      root.querySelector('variant-picker');

    const getHeaderBottom = () => {
      const header = document.querySelector('header.mj-header, .mj-header, header');
      if (!header) return 62;
      const rect = header.getBoundingClientRect();
      return Math.max(0, Math.min(rect.bottom, 160));
    };

    const sync = () => {
      animationFrame = null;

      if (!mobileQuery.matches) {
        button.hidden = true;
        button.classList.remove('is-visible');
        button.setAttribute('aria-hidden', 'true');
        return;
      }

      const sizeTarget = getSizeTarget();
      if (!sizeTarget) {
        button.hidden = true;
        return;
      }

      const headerBottom = getHeaderBottom();
      const targetRect = sizeTarget.getBoundingClientRect();
      const shouldShow = window.scrollY > 120 && targetRect.bottom <= headerBottom + 12;

      button.hidden = false;
      button.style.setProperty('--arizona-size-return-top', `${Math.round(headerBottom + 8)}px`);
      button.classList.toggle('is-visible', shouldShow);
      button.setAttribute('aria-hidden', String(!shouldShow));
    };

    const requestSync = () => {
      if (animationFrame) return;
      animationFrame = window.requestAnimationFrame(sync);
    };

    button.addEventListener('click', () => {
      const sizeTarget = getSizeTarget();
      if (!sizeTarget) return;

      const headerBottom = getHeaderBottom();
      const targetY =
        window.scrollY + sizeTarget.getBoundingClientRect().top - headerBottom - 42;

      button.classList.remove('is-visible');
      button.setAttribute('aria-hidden', 'true');
      window.scrollTo({ top: Math.max(0, targetY), behavior: 'smooth' });
    });

    window.addEventListener('scroll', requestSync, { passive: true });
    window.addEventListener('resize', requestSync);

    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', requestSync);
    }

    requestSync();
  };

  const initialize = (scope = document) => {
    updateShippingMessages();
    const selectedColor = document.querySelector(`${PRODUCT_SELECTOR} input[name^="Color"]:checked`);
    if (selectedColor) setEditorialColor(selectedColor.value);
    const reviewsSection = document.querySelector('[id*="arizona_reviews"]');
    if (reviewsSection && !document.getElementById('ArizonaReviews')) {
      const reviewsAnchor = document.createElement('span');
      reviewsAnchor.id = 'ArizonaReviews';
      reviewsAnchor.className = 'arizona-reviews-anchor';
      reviewsSection.prepend(reviewsAnchor);
    }

    const reviewLink = document.querySelector('.arizona-intro__rating');
    if (reviewLink && !reviewLink.dataset.arizonaReviewReady) {
      reviewLink.dataset.arizonaReviewReady = 'true';
      const ryviuRating = reviewLink.querySelector('[data-arizona-ryviu-rating]');
      const updateRyviuRating = () => {
        const ryviuTotal = ryviuRating?.querySelector('ryviu-widget-total');
        const renderedReviewData = (ryviuTotal?.dataset.ryviuRenderedKey || '').split('|')[1] || '';
        const [renderedRating = '0', renderedCount = '0'] = renderedReviewData.split(';');
        const visibleReviewCount = ryviuTotal?.querySelector('.review-count')?.textContent.trim() || '';
        const hasRyviuRating = Boolean(
          ryviuTotal &&
          (
            (Number.parseFloat(renderedRating) > 0 && Number.parseInt(renderedCount, 10) > 0) ||
            /[1-9]/.test(visibleReviewCount)
          )
        );
        reviewLink.classList.toggle('has-ryviu-rating', hasRyviuRating);
        reviewLink.setAttribute(
          'aria-label',
          hasRyviuRating ? 'Read customer reviews' : 'No customer reviews yet'
        );
      };
      updateRyviuRating();
      if (ryviuRating) {
        const ryviuObserver = new MutationObserver(updateRyviuRating);
        ryviuObserver.observe(ryviuRating, { childList: true, subtree: true, characterData: true });
        window.setTimeout(updateRyviuRating, 1200);
        window.setTimeout(updateRyviuRating, 3200);
      }
      reviewLink.addEventListener('click', (event) => {
        const target = document.getElementById('ArizonaReviews');
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
    scope.querySelectorAll(PRODUCT_SELECTOR).forEach(initializeSizeGuide);
    initializeSizeReturn();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  if (window.customElements?.whenDefined) {
    window.customElements.whenDefined('product-info').then(() => initialize());
  }

  document.addEventListener('variant:changed', () => initialize());
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  window.addEventListener('load', updateShippingMessages, { once: true });
  window.setTimeout(updateShippingMessages, 1200);
  document.addEventListener('click', (event) => {
    const colorCard = event.target.closest('[data-arizona-color-card]');
    if (colorCard) selectColor(colorCard.dataset.arizonaColorCard);
  });
})();
